export enum actionTypesReports {
  ListOfStockReport = "stockReportList",
  ListOfReserveStockReport = "reserveStockReportList",
  LastRefreshStockReport = "lastRefreshStockReport",
  ListOfPmxInventory = "pmxInventoryList",
  ListOfPmxInventoryDetail = "pmxInventoryDetailList",
  ListOfProductionStockReport = "productionStockReportList",
  ListOfRawMaterialOverviewStockReport = "rawMaterialOverviewStockReportList",
  ListOfRawMaterialStockReport = "rawMaterialStockReportList",
  ListOfProductReport = "productReportList",
  LastRefreshProductReport = "lastRefreshProductReport",
  ListOfCustomerStatus = "customerStatusList",
  ListOfCustomerOrder = "customerOrderList",
  ListOfDelivery = "deliveryList",
}
